import { useMutation, useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { SupportChatMessage, SupportThread } from "@/types/api";

/** The signed-in customer's current support conversation (null if none yet). */
export function useSupportThread() {
  return useQuery({
    queryKey: ["support-thread"],
    queryFn: () => api.get<SupportThread | null>("/api/support/thread"),
    staleTime: 30_000
  });
}

/** Customer sends a message → opens/appends the thread + emails the team. */
export function useSendSupportMessage() {
  return useMutation({
    mutationFn: (message: string) =>
      api.post<{ success: boolean; ticket_id: number; message: SupportChatMessage }>(
        "/api/support/messages",
        { message }
      )
  });
}
